import React from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ArrowRightIcon from '../ArrowRightIcon';

const FundsTable = () => {
  const navigate = useNavigate();
  const breakdown = useSelector((s) => s?.adminReducer?.dashboardFundBreakdown);
  // Normalize possible backend shapes
  const rows = Array.isArray(breakdown?.rows)
    ? breakdown.rows
    : Array.isArray(breakdown?.data)
    ? breakdown.data
    : Array.isArray(breakdown?.items)
    ? breakdown.items
    : Array.isArray(breakdown)
    ? breakdown
    : [];
  const funds = rows.map((r) => ({
    username: r?.user?.name || r?.username || r?.name || '-',
    email: r?.user?.email || r?.email || '-',
    fundraiser: r?.fundraiser?.organizationName || r?.fundraiser?.businessName || r?.fundraiser?.user?.name || r?.fundraiser?.name || r?.fundraiser || '-',
    funds: typeof r?.amount === 'number'
      ? (r.amount / 100).toFixed(2)
      : typeof r?.funds === 'number'
      ? r.funds.toFixed(2)
      : typeof r?.amountToDisburse === 'number'
      ? (r.amountToDisburse / 100).toFixed(2)
      : '-',
  }));

  return (
    <div className="summary w-full p-4 h-[380px] flex flex-col bg-white rounded-lg">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-[20px] font-poppins font-[600] text-[#303030] leading-none">Funds to be Disbursed (30 Days)</h2>
        <button onClick={()=> navigate('/admin/total-income?tab=to-be-disbursed')} className="text-[#00ADEF] text-[16px] font-poppins font-[500] border border-[#00ADEF] rounded-[6px] px-4 py-2 transition hover:bg-[#E6F7FB] flex items-center">
          View All
          <ArrowRightIcon className="ml-2" />
        </button>
      </div>
      <div className="flex-1 min-h-0 overflow-x-auto relative">
        {funds.length > 0 ? (
          <table className="min-w-full">
            <thead>
              <tr className="border-b border-gray-200">
                <th className="text-left py-3 px-4 text-[14px] font-poppins font-[500] text-[#303030] whitespace-nowrap">Username</th>
                <th className="text-left py-3 px-4 text-[14px] font-poppins font-[500] text-[#303030]">Email</th>
                <th className="text-left py-3 px-4 text-[14px] font-poppins font-[500] text-[#303030] whitespace-nowrap">Fundraiser</th>
                <th className="text-left py-3 px-4 text-[14px] font-poppins font-[500] text-[#303030]">Funds</th>
              </tr>
            </thead>
            <tbody>
              {funds.map((fund, index) => (
                <tr key={index} className="border-b border-gray-100">
                  <td className="py-3 px-4 text-[14px] font-poppins text-[#767676] whitespace-nowrap">{fund.username}</td>
                  <td className="py-3 px-4 text-[14px] font-poppins text-[#767676]">{fund.email}</td>
                  <td className="py-3 px-4 text-[14px] font-poppins text-[#767676] whitespace-nowrap">{fund.fundraiser}</td>
                  <td className="py-3 px-4 text-[14px] font-poppins text-[#767676]">${fund.funds}</td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none px-6">
            <div className="text-center bg-white/85 px-5 py-3 rounded-[12px]">
              <p className="text-[#303030] text-[15px] font-poppins font-[600] leading-[20px]">No data available</p>
              <p className="text-[#8A8A8A] text-[12px] font-poppins leading-[18px] mt-1">No funds to be disbursed in this period.</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FundsTable; 
